<div class="wrapper membership-wrapper">
  <ng-container *ngIf="page === '/buy-membership'">
    <h1 *ngIf="profileType === membershipTypes.FULL_FLEDGED">Članstvo</h1>
    <h1 *ngIf="profileType === membershipTypes.CLUB_FRIEND">Prijatelj kluba</h1>
    <h3 *ngIf="profileType === membershipTypes.FULL_FLEDGED">Budi podrška omiljenom klubu i postani član, te ostvari brojne pogodnosti namijenjene članovima.</h3>
    <h3 *ngIf="profileType === membershipTypes.CLUB_FRIEND">Budi podrška omiljenom klubu i postani prijatelj kluba, te ostvari brojne pogodnosti namijenjene prijateljima kluba.</h3>
  </ng-container>
  <ng-container *ngIf="page === '/buy-season-ticket'">
    <h1>GODIŠNJE ULAZNICE ZA SEZONU 24/25.</h1>
  </ng-container>

  <div class="white-container">
    <div class="event purchased-game-container">
      <div class="purchased-game-info">
        <div class="top">
          <p>
            <span class="purchased-game-title">{{"cart"|translate}}</span>
            <span class="fw-300 text-lowercase"> - {{"order.number"|translate}}: {{ cart?.id }} </span>
          </p>
        </div>
    
        <div class="sectors-cart-table-container">
          <table class="sectors-cart-table">
            <thead>
              <tr>
                <th class="sectors-cart-table-event">Stavka</th>
                <th class="sectors-cart-table-price">Ukupno</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let cartItem of cart?.items">
                <td class="sectors-cart-table-event">
                  {{ cartItem.eventName }} ({{ cartItem.sectorName }})
                  <ng-container *ngIf="cartItem.ticketOwner">- {{ cartItem.ticketOwner?.firstName }} {{ cartItem.ticketOwner?.lastName }}</ng-container>
                </td>
                <td class="sectors-cart-table-price">{{ cartItem.price | number: '1.2-2' }} {{ cartItem.currency }}</td>
              </tr>
              <tr *ngFor="let cartItem of cart?.additionalItems">
                <td class="sectors-cart-table-event">{{ cartItem.description }}</td>
                <td class="sectors-cart-table-price">{{ cartItem.price | number: '1.2-2' }} {{ cartItem.currency }}</td>
              </tr>
              <tr class="sectors-cart-table-total-price">
                <td class="sectors-cart-table-total-price-text">{{"total"|translate}}</td>
                <td>{{ cart?.totalPrice | number: '1.2-2' }} {{ cart?.currency }} / {{ cart?.totalInfoPrice | number: '1.2-2' }} {{ cart?.infoCurrency }}</td>
              </tr>
            </tbody>
          </table>
          <div class="button-container-order">
            <button class="cancel-button" (click)="cancelOrder()" >{{"cancel"|translate}}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  <div class="order-info-payment-container" *ngIf="cart">
    <div class="user-form-content">
      <div class="user-form-content-wrapper">
        <app-payment-info paymentInfoMessages="membership"></app-payment-info>
      </div>
    </div>
    <div class="user-form-content">
      <div class="user-form-content-wrapper w-100">
        <app-payment [hasPayment]="true" [orderInfo]="cart" [customerProfile]="customerProfile" [orderId]="orderId"></app-payment>
      </div>
    </div>
  </div>
</div>
